import React from 'react';
import { FormattedMessage } from 'react-intl';
import GetItOnAppleStorePNGDesktop from '@assets/png/apple-store-desktop.png';
import GetItOnAppleStorePNG from '@assets/png/apple-store.png';
import GetItOnPlayStorePNGDesktop from '@assets/png/google-play-desktop.png';
import GetItOnPlayStorePNG from '@assets/png/google-play.png';
import { useMediumQuery } from '@lib/hooks/useMediumQuery';
import ChevronHeader from '../../../components/chevron-header';
import { StepPatientSC } from './step-patient.styled';

const StepPatient: React.FC = () => {
  const isNarrowScreen = useMediumQuery('(max-width: 900px)');
  return (
    <StepPatientSC>
      <h1 className="header">
        <FormattedMessage id="reg.step_patient_main_header" />
      </h1>
      <h3 className="subheader">
        <FormattedMessage id="reg.step_patient_sub_header" />
      </h3>
      <div className="box">
        <ChevronHeader textId="reg.step_patient_block_1_header" />
        <p>
          <FormattedMessage id="reg.step_patient_block_1_copy" />
        </p>
      </div>
      <div className="box">
        <ChevronHeader textId="reg.step_patient_block_2_header" />
        <p>
          <FormattedMessage id="reg.step_patient_block_2_copy" />
        </p>
      </div>
      <div className="box">
        <ChevronHeader textId="reg.step_patient_block_3_header" />
        <p>
          <FormattedMessage id="reg.step_patient_block_3_copy" />
        </p>
      </div>
      <div className="box box-last">
        <h3 className="download-app-copy">
          <FormattedMessage id="reg.step_patient_footer_header" />
        </h3>
        <p>
          <FormattedMessage id="reg.step_patient_footer_copy" />
        </p>
        <span className="team-hilbi">
          <FormattedMessage id="reg.step_patient_footer_copy_team" />
        </span>
      </div>
      <div className="links">
        <a
          href="https://play.google.com/store/apps/details?id=com.hilbi&hl=cs&gl=US"
          className="google"
        >
          <img src={isNarrowScreen ? GetItOnPlayStorePNG : GetItOnPlayStorePNGDesktop} />
        </a>
        <a href="https://apps.apple.com/cz/app/hilbi/id1478748485" className="apple">
          <img src={isNarrowScreen ? GetItOnAppleStorePNG : GetItOnAppleStorePNGDesktop} />
        </a>
      </div>
    </StepPatientSC>
  );
};

export default StepPatient;
